import { BlockSortableProvider } from "../blocks/BlockHeader";
import { getBlockSortableId } from "../../utils";
import { ContactDetailsBlockContent, type ContactDetailsBlockContentProps } from "../blocks";

export interface SortableBlockRowProps extends ContactDetailsBlockContentProps {
  sortable: boolean;
}

export const SortableBlockRow = ({ sortable, ...props }: SortableBlockRowProps) => {
  if (!sortable) return <ContactDetailsBlockContent {...props} />;

  return (
    <BlockSortableProvider sortableId={getBlockSortableId(props.block, props.blockIndex)}>
      <ContactDetailsBlockContent {...props} />
    </BlockSortableProvider>
  );
};
